<div class="header">
  <div class="title">
    {{ selectedFile.name }}
  </div>

  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>
<div class="flex flex-wrap h-full">
  <div class="flex flex-wrap w-3/4 lt-xl:w-full border-right">
    <ng-template [ngIf]="selectedDocument">
      <iframe [src]="selectedDocument.pdf_url | safe" style="display: block; width: 100%"></iframe>
    </ng-template>
  </div>
  <div class="flex flex-auto flex-col w-1/4 side-panel">
    <div class="flex items-center px-3 pt-2 pb-1">
      <div class="flex flex-col">
        <div class="font-bold text-md text-secondary uppercase tracking-wider">{{ selectedFile.name }}</div>
      </div>
      <div class="ml-auto">
        <button mat-icon-button [matMenuTriggerFor]="moreMenu">
          <mat-icon [svgIcon]="'more_vert'"></mat-icon>
        </button>
        <mat-menu #moreMenu="matMenu">
          <button mat-menu-item (click)="deleteFile()">
            <mat-icon [svgIcon]="'delete'"></mat-icon>
            <span>Delete</span>
          </button>
        </mat-menu>
      </div>
    </div>

    <div class="flex flex-col overflow-auto pl-3 pr-5">
      <table class="w-full bg-transparent" mat-table [dataSource]="documentVersionsDataSource" [trackBy]="trackByFn">
        <!-- Transaction ID -->
        <ng-container matColumnDef="version">
          <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t" mat-header-cell mat-sort-header *matHeaderCellDef>
            <span class="whitespace-nowrap"> Version </span>
          </th>
          <td mat-cell *matCellDef="let document; let i = index">
            <div class="pr-6 font-medium text-sm text-secondary whitespace-nowrap">
              <a (click)="setSelectedDocument(document)">
                <div class="flex flex-row">
                  <div class="mt-1" style="text-decoration: underline">
                    Version {{ documentVersionsDataSource.data.length - i }}
                  </div>
                </div>
              </a>
            </div>
          </td>
        </ng-container>

        <!-- User -->
        <ng-container matColumnDef="created_by">
          <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t" mat-header-cell mat-sort-header *matHeaderCellDef>
            <span class="whitespace-nowrap"> Created By </span>
          </th>
          <td mat-cell *matCellDef="let document">
            <span class="font-medium text-sm text-secondary whitespace-nowrap">
              {{ document.created_by ? document.created_by.full_name : '' }}
            </span>
          </td>
        </ng-container>

        <!-- Date -->
        <ng-container matColumnDef="created_at">
          <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t" mat-header-cell mat-sort-header *matHeaderCellDef>
            <span class="whitespace-nowrap"> Date </span>
          </th>
          <td mat-cell *matCellDef="let document">
            <span class="font-medium text-sm text-secondary whitespace-nowrap">
              {{ document.created_at | date: 'MMM dd, y' }}
            </span>
          </td>
        </ng-container>

        <!-- Name -->
        <ng-container matColumnDef="actions">
          <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t" mat-header-cell mat-sort-header *matHeaderCellDef>
            <span class="whitespace-nowrap"> Actions </span>
          </th>
          <td mat-cell *matCellDef="let document">
            <span class="font-medium text-sm text-secondary whitespace-nowrap">
              <button mat-icon-button class="delete-file" (click)="deleteDocument(document)">
                <mat-icon [svgIcon]="'delete'"></mat-icon>
              </button>
              <button mat-icon-button (click)="downloadDocument(document)">
                <mat-icon class="icon" [svgIcon]="'get_app'"></mat-icon>
              </button>
            </span>
          </td>
        </ng-container>

        <!-- Footer -->
        <ng-container matColumnDef="documentVersionsTableFooter">
          <td class="px-3 border-none" mat-footer-cell *matFooterCellDef colspan="6">
            <input style="display: none" type="file" (change)="onFileChanged($event)" #fileInput />
            <button mat-button mat-stroked-button [color]="'primary'" (click)="fileInput.click()">
              Upload New File Version
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="documentVersionsColumns"></tr>
        <tr class="order-row h-16" mat-row *matRowDef="let row; columns: documentVersionsColumns"></tr>
        <tr class="py-3" mat-footer-row *matFooterRowDef="['documentVersionsTableFooter']"></tr>
      </table>
    </div>

    <div class="w-full mt-3 pl-3 pr-5">
      <comment-view [relatedToId]="selectedFile.id" relatedToType="FileResource" [account]="account"></comment-view>
    </div>
  </div>
</div>
